/**
 * Catálogo del "Historial de pagos" del perfil del cliente (payment_records).
 *
 * El estado se muestra con el texto EXACTO de la BD (`status`); el color sale de `statusCategory`,
 * que calcula backend: toda variante que empiece por "CANCEL" ("CANCELLLED", "CANCELLED (PAGO
 * REASIGNADO…)") es CANCELLED. Un estado desconocido (`statusCategory` null) va en gris.
 */
export const PAYMENT_STATUSES = ["APPLIED", "PENDING_APPLICATION", "CANCELLED", "ADJUSTED"];

const PAYMENT_STATUS_TONES = {
  APPLIED: "green",
  PENDING_APPLICATION: "yellow",
  CANCELLED: "red",
  ADJUSTED: "purple",
};

/** Valor del filtro "Crédito" para los pagos sin aplicaciones (se muestran como "N/A"). */
export const WITHOUT_CREDIT = "N/A";

export const paymentStatusBadge = (payment) => ({
  tone: PAYMENT_STATUS_TONES[payment.statusCategory] || "gray",
  label: payment.status?.trim() || "—",
});

/** Traduce los filtros de la UI ({ status, credit, from, to }) a los query params del endpoint. */
export const toPaymentHistoryParams = ({ status, credit, from, to }) => ({
  status,
  creditUuid: credit === WITHOUT_CREDIT ? "" : credit,
  withoutCredit: credit === WITHOUT_CREDIT ? true : "",
  from,
  to,
});

/** "Cuota 3" o "Cuotas 3, 4, 5" para una línea de la celda Crédito / cuota. */
export const formatQuotaNumbers = (quotaNumbers = []) => {
  if (quotaNumbers.length === 0) return "—";
  return `${quotaNumbers.length === 1 ? "Cuota" : "Cuotas"} ${quotaNumbers.join(", ")}`;
};
